import type { Timezone } from '@getaccept/lib-shared/src/types/time-zone';

export const timezones: Timezone[] = [
  { key: '-12:00', label: '(GMT-12:00) International Date Line West', zone: 'Etc/GMT-12' },
  { key: '-11:00', label: '(GMT-11:00) Niue, American Samoa', zone: 'Pacific/Niue' },
  { key: '-10:00', label: '(GMT-10:00) Hawaii-Aleutian', zone: 'Pacific/Honolulu' },
  { key: '-09:00', label: '(GMT-09:00) Alaska', zone: 'America/Anchorage' },
  { key: '-08:00', label: '(GMT-08:00) Pacific Time (US & Canada)', zone: 'America/Los_Angeles' },
  { key: '-07:00', label: '(GMT-07:00) Mountain Time (US & Canada)', zone: 'America/Denver' },
  { key: '-06:00', label: '(GMT-06:00) Central Time (US & Canada)', zone: 'America/Chicago' },
  { key: '-05:00', label: '(GMT-05:00) Eastern Time (US & Canada)', zone: 'America/New_York' },
  { key: '-04:00', label: '(GMT-04:00) Atlantic Time (Canada)', zone: 'America/Halifax' },
  { key: '-03:30', label: '(GMT-03:30) Newfoundland', zone: 'America/St_Johns' },
  { key: '-03:00', label: '(GMT-03:00) Buenos Aires, Brasília', zone: 'America/Sao_Paulo' },
  { key: '-02:00', label: '(GMT-02:00) South Georgia', zone: 'Atlantic/South_Georgia' },
  { key: '-01:00', label: '(GMT-01:00) Azores', zone: 'Atlantic/Azores' },
  { key: '+00:00', label: '(GMT+00:00) UTC, London', zone: 'Europe/London' },
  { key: '+01:00', label: '(GMT+01:00) Berlin, Paris, Stockholm', zone: 'Europe/Paris' },
  { key: '+02:00', label: '(GMT+02:00) Athens, Bucharest, Cairo', zone: 'Europe/Athens' },
  { key: '+03:00', label: '(GMT+03:00) Moscow, Nairobi', zone: 'Europe/Moscow' },
  { key: '+03:30', label: '(GMT+03:30) Tehran', zone: 'Asia/Tehran' },
  { key: '+04:00', label: '(GMT+04:00) Dubai, Baku', zone: 'Asia/Dubai' },
  { key: '+04:30', label: '(GMT+04:30) Kabul', zone: 'Asia/Kabul' },
  { key: '+05:00', label: '(GMT+05:00) Islamabad, Karachi', zone: 'Asia/Karachi' },
  { key: '+05:30', label: '(GMT+05:30) Mumbai, Kolkata', zone: 'Asia/Kolkata' },
  { key: '+05:45', label: '(GMT+05:45) Kathmandu', zone: 'Asia/Kathmandu' },
  { key: '+06:00', label: '(GMT+06:00) Dhaka, Almaty', zone: 'Asia/Dhaka' },
  { key: '+06:30', label: '(GMT+06:30) Yangon', zone: 'Asia/Yangon' },
  { key: '+07:00', label: '(GMT+07:00) Bangkok, Jakarta', zone: 'Asia/Bangkok' },
  { key: '+08:00', label: '(GMT+08:00) Beijing, Singapore', zone: 'Asia/Shanghai' },
  { key: '+09:00', label: '(GMT+09:00) Tokyo, Seoul', zone: 'Asia/Tokyo' },
  { key: '+09:30', label: '(GMT+09:30) Adelaide', zone: 'Australia/Adelaide' },
  { key: '+10:00', label: '(GMT+10:00) Sydney, Brisbane', zone: 'Australia/Sydney' },
  { key: '+11:00', label: '(GMT+11:00) Solomon Islands, Vladivostok', zone: 'Pacific/Guadalcanal' },
  { key: '+12:00', label: '(GMT+12:00) Fiji, Auckland', zone: 'Pacific/Auckland' },
  { key: '+13:00', label: '(GMT+13:00) Tonga', zone: 'Pacific/Tongatapu' },
];
